import { useTagsManagement } from 'app/components/tags-management/useTagsManagement'
import { TagsManagementShadcnComponent } from 'app/components/tags-management/TagsManagementShadcnComponent'

export const handle = {
  title: `Tags Management`,
  breadcrumb: `Tags`,
}

export default function TagsManagement(): React.ReactElement {
  const { tabs } = useTagsManagement()
  return <TagsManagementShadcnComponent tabs={tabs} />
}
